import { render, staticRenderFns } from "./exit_movement_item_index.vue?vue&type=template&id=1c230f0a&scoped=true&"
import script from "./exit_movement_item_index.vue?vue&type=script&lang=js&"
export * from "./exit_movement_item_index.vue?vue&type=script&lang=js&"
import style0 from "./exit_movement_item_index.vue?vue&type=style&index=0&id=1c230f0a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c230f0a",
  null
  
)

export default component.exports